/**
 * 20250827 修复border-info 协同异常BUG
 *  1. 目前传输的模式是直接将 cfg["borderInfo"] 全量传输；
 *  2. 并且存储时，是直接push到cfg["borderInfo"]中，并未做任何处理；
 *  3. 这就导致一个问题，border-none 可能先 push 到数组中， 而 border-all 后push；导致顺序错误；
 *  4. fix: 修复方法，每次传输之前，都重新整理border-info数组，自行处理 相同的row col borderType
 */

import Store from "../store";

/**
 * 格式化borderInfo
 * @params {config} 为了适应不同的参数，实现对不同数据的边框处理，有些边框不是简单存储到 Store 上的
 */
function formatBorderInfo(config) {
	if (!config || !config["borderInfo"]) {
		config = $.extend(true, {}, Store.config);
	}

	const allBorderInfo = config["borderInfo"] || [];

	// 根据 timestamp 升序排序，后操作的记录在后
	const sortArray = allBorderInfo.sort((a, b) => a.timestamp - b.timestamp);

	console.log(sortArray);
	return sortArray;
}

export { formatBorderInfo };
